import React from 'react'
import { Link } from 'react-router-dom'
import { C, fOutfit, fBody, fMono, PublicNav, PublicFooter } from '../../../Shared/Brand'
import { Icon } from '../../../Shared/Icons'

const STEPS = [
  { n: 1, title: 'Register', desc: 'Enter your details and open a Xperia Capital account.' },
  { n: 2, title: 'Deposit', desc: 'Fund your account through a secure, supported method.' },
  { n: 3, title: 'Start Trading', desc: 'Access global markets and the Arbitrade Bot from your dashboard.' },
]

const ECOSYSTEM = [
  { icon: 'gear', title: 'Fixed Leverage up to 1:1000', desc: 'Consistent trading conditions regardless of account size.' },
  { icon: 'bolt', title: 'Fast Market Execution', desc: 'Orders are processed with minimal delay across account types.' },
  { icon: 'layers', title: 'Multiple Markets, One Account', desc: 'Forex, metals, energies, indices, and crypto in a single login.' },
  { icon: 'shrink', title: 'Minimum Trade Size from 0.01 Lots', desc: 'Low-risk entry points for testing strategies.' },
  { icon: 'infinity', title: 'Unlimited Trade Volume', desc: 'No arbitrary cap on total position size.' },
  { icon: 'headset', title: 'Responsive Support', desc: 'A dedicated support ticket system inside your dashboard.' },
]

function HeroArt() {
  return (
    <div aria-hidden style={{ position: 'absolute', inset: 0, overflow: 'hidden', zIndex: 0 }}>
      <div style={{ position: 'absolute', top: '-30%', right: '-8%', width: '480px', height: '480px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(247,147,26,0.14), transparent 65%)' }} />
    </div>
  )
}

function DeviceCard({ label, style }) {
  return (
    <div style={{
      position: 'relative', borderRadius: '16px', overflow: 'hidden', minHeight: '240px',
      background: 'linear-gradient(150deg, #12161f, #05070a)', border: `1px solid ${C.dbdr}`,
      boxShadow: '0 24px 48px rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', ...style,
    }}>
      <div style={{ position: 'absolute', inset: 0, backgroundImage: 'linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)', backgroundSize: '28px 28px' }} />
      <div style={{ position: 'relative', textAlign: 'center', padding: '24px' }}>
        <div style={{ width: '46px', height: '46px', borderRadius: '12px', background: 'rgba(247,147,26,0.14)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px', fontSize: '20px' }}>📱</div>
        <div style={{ fontSize: '12px', color: C.ltx3, fontFamily: fMono, maxWidth: '220px', margin: '0 auto' }}>{label}</div>
      </div>
    </div>
  )
}

export default function AccountTypePage({ name, tagline, description, spec, switchTo }) {
  return (
    <div style={{ background: C.white, color: C.tx, fontFamily: fBody, minHeight: '100vh' }}>
      <style>{`
        .xat-steps-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; text-align: center; }
        .xat-hero-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 40px; align-items: center; }
        .xat-desc-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 48px; align-items: center; }
        .xat-eco-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 24px; text-align: center; }
        .xat-spec-wrap { display: flex; gap: 16px; align-items: stretch; }
        .xat-spec-table { flex: 1; border-collapse: collapse; width: 100%; font-size: 13px; border: 1px solid ${C.bdr}; border-radius: 14px; overflow: hidden; box-shadow: 0 4px 16px rgba(0,0,0,0.04); }
        .xat-spec-table td { padding: 12px 16px; border-bottom: 1px solid ${C.bdr}; }
        .xat-spec-table tr:hover { background: ${C.light}; }
        .xat-spec-table td:first-child { color: ${C.tx3}; }
        .xat-spec-table td:last-child { color: ${C.tx}; font-weight: 600; text-align: right; }
        .xat-switch-col { display: flex; flex-direction: column; gap: 10px; width: 90px; flex-shrink: 0; }
        .xat-switch { flex: 1; min-height: 90px; border-radius: 14px; background: linear-gradient(180deg, ${C.primary}, ${C.primaryDark}); display: flex; align-items: center; justify-content: center; writing-mode: vertical-rl; letter-spacing: 0.04em; font-weight: 700; font-size: 13px; color: ${C.dark}; text-decoration: none; box-shadow: 0 8px 20px rgba(247,147,26,0.25); }
        @media (max-width: 700px) { .xat-steps-grid, .xat-hero-grid, .xat-desc-grid, .xat-spec-wrap { grid-template-columns: 1fr !important; flex-direction: column !important; } .xat-switch-col { flex-direction: row; width: 100%; } .xat-switch { writing-mode: horizontal-tb; min-height: 0; padding: 10px 0; } }
      `}</style>
      <PublicNav active="Trading" />

      {/* HERO — dark, decorative */}
      <section style={{ padding: '130px 24px 60px', background: C.dark, color: C.ltx, borderBottom: `1px solid ${C.dbdr}`, position: 'relative', overflow: 'hidden' }}>
        <HeroArt />
        <div className="xat-hero-grid" style={{ maxWidth: '1100px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
          <div>
            <div style={{ fontSize: '11px', fontFamily: fMono, letterSpacing: '0.14em', color: C.primary, textTransform: 'uppercase', marginBottom: '10px' }}>Account Types</div>
            <h1 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(32px,5vw,48px)', lineHeight: 1.1, margin: '0 0 14px' }}>{name} Account</h1>
            <p style={{ fontSize: '16px', fontWeight: 500, color: C.ltx2, maxWidth: '440px', lineHeight: 1.3 }}>{tagline}</p>
          </div>
          <DeviceCard label={`${name} account hero device mockup`} />
        </div>
      </section>

      {/* STEPS — light */}
      <section style={{ padding: '64px 24px', maxWidth: '900px', margin: '0 auto' }}>
        <h2 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(28px,4vw,38px)', lineHeight: 1.1, textAlign: 'center', margin: '0 0 36px', color: C.tx }}>Open Account in 3 Steps</h2>
        <div className="xat-steps-grid">
          {STEPS.map(s => (
            <div key={s.n}>
              <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: C.primary, color: C.dark, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px', boxShadow: '0 6px 16px rgba(247,147,26,0.3)' }}>{s.n}</div>
              <div style={{ fontFamily: fOutfit, fontWeight: 600, fontSize: '20px', lineHeight: 1.1, marginBottom: '6px', color: C.tx }}>{s.title}</div>
              <p style={{ fontSize: '16px', fontWeight: 500, color: C.tx3, lineHeight: 1.3, margin: 0 }}>{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* BENEFITS — light, tinted */}
      <section style={{ padding: '64px 24px', borderTop: `1px solid ${C.bdr}`, background: C.light }}>
        <div className="xat-desc-grid" style={{ maxWidth: '1100px', margin: '0 auto' }}>
          <div>
            <h2 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(28px,4vw,38px)', lineHeight: 1.1, margin: '0 0 16px', color: C.tx, letterSpacing: '-0.01em' }}>Discover the Benefits of {name}</h2>
            {description.map((p, i) => <p key={i} style={{ fontSize: '16px', fontWeight: 500, color: C.tx2, lineHeight: 1.3, marginBottom: '14px' }}>{p}</p>)}
          </div>
          <DeviceCard label={`${name} account device mockup`} />
        </div>
      </section>

      {/* SPEC — light */}
      <section style={{ padding: '64px 24px', maxWidth: '1100px', margin: '0 auto' }}>
        <h2 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(28px,4vw,38px)', lineHeight: 1.1, textAlign: 'center', margin: '0 0 28px', color: C.tx }}>{name} Account Specification</h2>
        <div className="xat-spec-wrap">
          <table className="xat-spec-table">
            <tbody>
              {spec.map(row => (
                <tr key={row.label}><td>{row.label}</td><td>{row.value}</td></tr>
              ))}
            </tbody>
          </table>
          <div className="xat-switch-col">
            {switchTo.map(s => (
              <Link key={s.label} to={s.to} className="xat-switch">{s.label}</Link>
            ))}
          </div>
        </div>
        <div style={{ textAlign: 'center', marginTop: '28px' }}>
          <Link to="/signup" style={{ display: 'inline-block', background: 'transparent', border: `1px solid ${C.primary}`, color: C.primaryDark, fontWeight: 700, fontSize: '13px', padding: '11px 28px', borderRadius: '999px', textDecoration: 'none' }}>Sign Up</Link>
        </div>
      </section>

      {/* ECOSYSTEM — dark band */}
      <section style={{ padding: '72px 24px', background: C.dark }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
          <h2 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(28px,4vw,38px)', lineHeight: 1.1, textAlign: 'center', margin: '0 0 12px', color: C.ltx }}>The Ultimate Ecosystem for Traders</h2>
          <p style={{ fontSize: '16px', fontWeight: 500, color: C.ltx2, textAlign: 'center', maxWidth: '560px', margin: '0 auto 44px', lineHeight: 1.3 }}>Trade forex, crypto, commodities, and more with conditions tailored to your strategy.</p>
          <div className="xat-eco-grid">
            {ECOSYSTEM.map(e => (
              <div key={e.title}>
                <div style={{ color: C.primary, display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
                  <Icon name={e.icon} size={40} strokeWidth={1.4} />
                </div>
                <div style={{ fontFamily: fOutfit, fontWeight: 600, fontSize: '20px', lineHeight: 1.1, marginBottom: '10px', color: C.ltx }}>{e.title}</div>
                <p style={{ fontSize: '16px', fontWeight: 500, color: C.ltx3, lineHeight: 1.3, margin: 0 }}>{e.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <PublicFooter />
    </div>
  )
}
